import 'babel-polyfill'
import 'whatwg-fetch'
import './sentry'

import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom'
import App from './components/App';
import './stylesheets/main.scss'

ReactDOM.render((
  <Router>
    <Route component={App} />
  </Router>
), document.getElementById('root'))
